import { RegisterSupplierForm } from 'app/main/contacts/suppliers/forms/RegisterSupplierForm';
import { IObjectWithIdAndIdentifier, IOrderV2, IRegisterSupplierRequest, ISupplierSummaryWithOrderStats } from 'gen/ApiClient';
import React, { useState } from 'react';
import { AddOrderLinesRequestForm } from '../addLines/AddOrderLinesRequestForm';
import { mapRegisterSupplierRequestToSupplierSummaryWithOrderStats } from './mapRegisterSupplierRequestToSupplierSummaryWithOrderStats';
import { RegisterOrderForm } from './RegisterOrderForm';
import { SelectExistingOrderOrNewDialog } from './selectOrderToPlace/SelectExistingOrderOrNewDialog';
import { SelectSupplierForOrderDialog } from './selectSupplier/SelectSupplierForOrderDialog';

type Mode = 'select-supplier' | 'new-supplier' | 'select-existing-order' | 'add-lines-to-existing-order' | 'new-order';

interface IProps {
	confirm: (id: string) => void;
	cancel: VoidFunction;
	patient?: IObjectWithIdAndIdentifier<string>;
}

export const RegisterOrder = ({ confirm, cancel, patient }: IProps) => {
	const [state, setState] = useState<Mode>('select-supplier');
	const [selectedSupplier, setSelectedSupplier] = useState<ISupplierSummaryWithOrderStats>();
	const [selectedOrder, setSelectedOrder] = useState<IOrderV2>();

	const onSetSupplier = (supplier: ISupplierSummaryWithOrderStats) => {
		setSelectedSupplier(supplier);
		setState(supplier.hasOrdersToPlaceWithSupplier ? 'select-existing-order' : 'new-order');
	};

	const onNewSupplier = (id: string, request: IRegisterSupplierRequest) => {
		setSelectedSupplier(mapRegisterSupplierRequestToSupplierSummaryWithOrderStats(id, request));
		setState('new-order');
	};

	const onSelectExistingOrder = (order: IOrderV2) => {
		setSelectedOrder(order);
		setState('add-lines-to-existing-order');
	};

	if (state === 'select-supplier') {
		return (
			<SelectSupplierForOrderDialog
				open
				confirm={onSetSupplier}
				cancel={cancel}
				onNew={() => setState('new-supplier')}
			/>
		);
	} else if (state === 'new-supplier') {
		return (
			<RegisterSupplierForm
				open
				confirm={onNewSupplier}
				previous={() => setState('select-supplier')}
				cancel={cancel}
			/>
		);
	} else if (state === 'select-existing-order' && selectedSupplier !== undefined) {
		return (
			<SelectExistingOrderOrNewDialog
				open
				confirm={onSelectExistingOrder}
				cancel={cancel}
				previous={() => setState('select-supplier')}
				supplier={selectedSupplier}
				onNew={() => setState('new-order')}
			/>
		);
	} else if (state === 'add-lines-to-existing-order' && selectedOrder !== undefined) {
		return (
			<AddOrderLinesRequestForm
				open
				confirm={() => confirm(selectedOrder.id)}
				cancel={cancel}
				item={selectedOrder}
				previous={() => setState('select-supplier')}
				patient={patient}
			/>
		);
	} else if (state === 'new-order' && selectedSupplier !== undefined) {
		return (
			<RegisterOrderForm
				open
				confirm={confirm}
				cancel={cancel}
				supplier={selectedSupplier}
				previous={() => setState('select-supplier')}
				patient={patient}
			/>
		);
	} else {
		return <></>;
	}
};
